import { tv as e } from "tailwind-variants";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/Label/Label.tsx
var n = e({ base: "font-ic-web-body text-ic-web-heading text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70" });
function r({ className: e, ...r }) {
	return /* @__PURE__ */ t("label", {
		...r,
		className: n({ className: e })
	});
}
//#endregion
export { r as Label, n as labelVariants };
